__turbopack_context__.v({
  "comparison": "PerformanceCard-module__KACfCG__comparison",
  "description": "PerformanceCard-module__KACfCG__description",
  "metric": "PerformanceCard-module__KACfCG__metric",
  "performanceCard": "PerformanceCard-module__KACfCG__performanceCard",
  "pulseGlow": "PerformanceCard-module__KACfCG__pulseGlow",
  "statusIndicator": "PerformanceCard-module__KACfCG__statusIndicator",
  "statusRow": "PerformanceCard-module__KACfCG__statusRow",
});
